import { config } from '@cotera/client/config/config';

type SlackPostInstallContext = {
  orgId: string;
  userId: string;
};

const waitForPostMessage = (
  expectedMessage: string,
  onMessage: () => void
): void => {
  let timeoutId: number | undefined = undefined;
  const handler = (event: MessageEvent) => {
    if (event.data !== expectedMessage) {
      return;
    }

    window.removeEventListener('message', handler);
    if (timeoutId !== undefined) {
      window.clearTimeout(timeoutId);
    }
    onMessage();
  };

  window.addEventListener('message', handler);
  timeoutId = window.setTimeout(() => {
    window.removeEventListener('message', handler);
  }, 5 * 60 * 1000);
};

const openCenteredPopup = (
  url: string,
  name: string,
  width = 600,
  height = 700
): Window => {
  const left = window.screenX + (window.outerWidth - width) / 2;
  const top = window.screenY + (window.outerHeight - height) / 2;
  const popup = window.open(
    url,
    name,
    `width=${width},height=${height},left=${left},top=${top},popup=yes`
  );

  if (popup === null) {
    throw new Error('Could not open popup');
  }

  return popup;
};

export const triggerSlackBotInstall = (
  context: SlackPostInstallContext,
  onSuccess: () => void
): void => {
  const baseUrl = config.apiUrl.replace(/\/api\/v1\/?$/, '');
  const authorizeUrl =
    `${baseUrl}/api/v1/slack/oauth/authorize` +
    `?orgId=${encodeURIComponent(context.orgId)}` +
    `&userId=${encodeURIComponent(context.userId)}`;

  waitForPostMessage('coco-bot-connected', onSuccess);
  openCenteredPopup(authorizeUrl, 'install-slack-bot-app');
};
